export const trimSpaces = (value: string | undefined): string | undefined => {

	if(!value) {
		return value
	}

	if (typeof value === 'string') {
		// remove spaces on start and end
		value =  value.trim()
		// remove double spaces in text
		return value.replace(/ +/g, ' ')
	}
	return value
}